import { cn } from '../../lib/utils';

// Mapping des noms de restaurants vers leurs logos
const restaurantLogos = {
    "Ma biche sur le toit": "/logos/ma-biche-sur-le-toit.png",
    "Compagnie Française": "/logos/compagnie-francaise.png",
    "Coup de bambou": "/logos/coup-de-bambou.png",
    "Jacques Balma": "/logos/jacques-balma.png",
    "Jacques Blagnac": "/logos/jacques-balma.png",  // Utilise le même logo que Balma
    "Compagnie Busca": "/logos/compagnie-busca.png",
    "Café Chouchou": "/logos/cafe-chouchou.png",
    "Sous les pins": "/logos/sous-les-pins.png",
};

// Sous-titres pour certains restaurants (pour distinguer les établissements)
const restaurantSubtitles = {
    "Jacques Balma": "Balma",
    "Jacques Blagnac": "Blagnac",
};

export const RestaurantSelector = ({ 
    restaurants, 
    selectedId, 
    onSelect,
    className,
    showConsolidated = false,
    isConsolidated = false,
    onConsolidatedSelect
}) => {
    return (
        <div 
            className={cn(
                "grid grid-cols-4 md:grid-cols-8 gap-3",
                className
            )}
            data-testid="restaurant-selector"
        >
            {/* Bouton Vue Consolidée */}
            {showConsolidated && onConsolidatedSelect && (
                <button
                    onClick={onConsolidatedSelect}
                    className={cn(
                        "relative h-20 md:h-24 rounded-xl overflow-hidden cursor-pointer transition-all duration-200",
                        "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                        "hover:scale-105 hover:shadow-lg",
                        "bg-gradient-to-br from-primary/20 to-primary/5 border-2 border-dashed",
                        isConsolidated 
                            ? "ring-2 ring-primary ring-offset-2 shadow-lg border-primary" 
                            : "border-border hover:border-primary/50"
                    )}
                    data-testid="consolidated-btn"
                >
                    <div className="absolute inset-0 flex flex-col items-center justify-center p-2">
                        <div className="text-2xl mb-1">📊</div>
                        <span className="font-semibold text-xs text-center">Consolidé</span>
                    </div>
                </button>
            )}
            
            {restaurants.map((restaurant) => {
                const logo = restaurantLogos[restaurant.name];
                const subtitle = restaurantSubtitles[restaurant.name];
                
                return (
                    <button
                        key={restaurant.id}
                        onClick={() => onSelect(restaurant)}
                        className={cn(
                            "relative h-20 md:h-24 rounded-xl overflow-hidden cursor-pointer transition-all duration-200",
                            "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                            "hover:scale-105 hover:shadow-lg",
                            selectedId === restaurant.id 
                                ? "ring-2 ring-primary ring-offset-2 shadow-lg" 
                                : "ring-1 ring-border"
                        )}
                        data-testid={`restaurant-card-${restaurant.id}`}
                    >
                        {/* Fond noir */}
                        <div className="absolute inset-0 bg-black" />
                        
                        {logo ? (
                            /* Logo centré avec sous-titre optionnel */
                            <div className="absolute inset-0 flex flex-col items-center justify-center p-2">
                                <img
                                    src={logo}
                                    alt={restaurant.name}
                                    className={cn(
                                        "max-w-full object-contain",
                                        subtitle ? "max-h-[65%]" : "max-h-full"
                                    )}
                                />
                                {subtitle && (
                                    <span className="text-white text-xs font-medium mt-1 tracking-wider">
                                        {subtitle}
                                    </span>
                                )}
                            </div>
                        ) : (
                            /* Fallback : nom du restaurant en blanc sur fond noir */
                            <div className="absolute inset-0 flex items-center justify-center p-2">
                                <h3 className="text-white text-xs font-heading font-bold text-center">
                                    {restaurant.name}
                                </h3>
                            </div>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export const RestaurantCard = ({ 
    restaurant, 
    onClick,
    selected = false 
}) => {
    const logo = restaurantLogos[restaurant.name];
    
    return (
        <button
            onClick={onClick}
            className={cn(
                "relative h-20 md:h-24 w-full rounded-xl overflow-hidden cursor-pointer transition-all duration-200",
                "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                "hover:scale-105 hover:shadow-lg",
                selected 
                    ? "ring-2 ring-primary ring-offset-2 shadow-lg" 
                    : "ring-1 ring-border"
            )}
            data-testid={`restaurant-card-${restaurant.id}`}
        >
            {/* Fond noir */}
            <div className="absolute inset-0 bg-black" />
            
            {logo ? (
                /* Logo centré */
                <div className="absolute inset-0 flex items-center justify-center p-2">
                    <img
                        src={logo}
                        alt={restaurant.name}
                        className="max-w-full max-h-full object-contain"
                    />
                </div>
            ) : (
                /* Fallback : nom du restaurant en blanc sur fond noir */
                <div className="absolute inset-0 flex items-center justify-center p-2">
                    <h3 className="text-white text-xs font-heading font-bold text-center">
                        {restaurant.name}
                    </h3>
                </div>
            )}
        </button>
    );
};

export default RestaurantSelector;
